/* eslint-disable eqeqeq */
import React, { Fragment } from "react";
import { withStyles } from "@material-ui/core/styles";
import Loader from "./subComponents/loader"
import ErrorModal from "./subComponents/errorModal";
import moment from "moment-timezone";
import BrokenImageIcon from "../assets/brokenImage.png";
import UploadPDFStyle from "../styles/uploadPDFStyle";
import { PDFViewer } from './PDFViewer';

class UploadPDF extends React.Component {

    componentDidMount() {
        let { GetPDFInfo, match } = this.props;
        let OrderId = match && match.params && match.params.orderId;
        GetPDFInfo && GetPDFInfo({ OrderId });
    }

    loadImage = (url) => {
        return 'data:application/pdf;base64,' + url;
    }

    getDateFormat = (Date) => {
        let timeZone = moment.tz.guess();
        return moment.tz(Date, timeZone).format('L');
    }

    getImageArray = () => {
        let imagesMainUI = [];
        const { classes, uploadedPdfs } = this.props;
        if(uploadedPdfs != null && uploadedPdfs.length != 0)
        {
            if(uploadedPdfs.DocumentUploadImages === null || uploadedPdfs.DocumentUploadImages.length === 0){
                imagesMainUI.push(
                    <Fragment>
                        <p className={classes.noPdfContent}>No PDF found for the provided order ID</p>
                    </Fragment>
                );
            }
            else{
                imagesMainUI.push(
                    <Fragment>
                        {this.getImages(uploadedPdfs, uploadedPdfs.orderId)}
                    </Fragment>
                );
            }
        }
        else
        {
            imagesMainUI.push(
                <Fragment>
                    <p className={classes.noPdfContent}></p>
                </Fragment>
            ); 
        }
        return imagesMainUI;
    }

    getImages = (imageArray, indexMain) => {
        let imagesSubUI = [];
        const { classes } = this.props;
        imageArray.DocumentUploadImages.length !== 0 && imageArray.DocumentUploadImages.forEach((image, subIndex) => {
            imagesSubUI.push(<Fragment>
                    { image.ImageBase64Data ?
                        <div style={{backgroundColor: 'green',width: '100%', height: '100%'}}>
                            <PDFViewer
                                file={this.loadImage(image.ImageBase64Data)}
                                style={{ minWidth: 760, height: 520 }}
                            />
                        </div>
                        :
                        <div style={{backgroundColor: 'blue',width: '100%', height: '100%'}}>
                            <div className={classes.imageDefaultWrapper}>
                                <embed type="application/pdf" className={classes.imageDefault} src={BrokenImageIcon} alt="" />
                                <label className={classes.imageDefaultLabel}>Unable to load images</label>
                            </div>
                        </div> 
                    }
            </Fragment>)
        })
        return imagesSubUI;
    }

    render() {
        let {
            errorModalOpen,
            loading,
            ToggleErrorModal,
        } = this.props;
        return (<Fragment style={{width: '100%', height: '100%'}}>
                <div style={{backgroundColor: 'gray',width: '100%', height: '100%'}}>
                    {this.getImageArray()}
                </div>
                <ErrorModal modalOpen={errorModalOpen} closeModal={() => ToggleErrorModal(false)} />
                {loading ? <Loader /> : ""}
            </Fragment>
        )
    }
}

export default withStyles(UploadPDFStyle)(UploadPDF);
